import Vue from 'vue'
import VueRouter from 'vue-router'
import Assistant from '../views/Assistant.vue'
import bsGreetJob from '../views/boss/GreetJob.vue'
import bslog from '../views/boss/log.vue'
import zlGreetJob from '../views/zhilian/GreetJob.vue'
import zllog from '../views/zhilian/log.vue'
import lpGreetJob from '../views/liepin/GreetJob.vue'
import lplog from '../views/liepin/log.vue'
import resume from '../views/resume.vue'
import search from '../views/search.vue'
import addRes from '../components/resume/add.vue'
import pdf from '../components/export/pdf.vue'
import interview from '../components/interview/config.vue'
import myinterview from '../components/interview/myInterview.vue'
import BiBoard from '../views/BiBoard.vue'

Vue.use(VueRouter)
const routes = [{
    path: '/assistant',
    name: 'assistant',
    component: Assistant,
    meta: {
      title: '熵聘AI招聘助手'
    }
  }, {
    path: '/interview',
    name: 'interview',
    component: interview
  }, {
    path: '/respdf',
    name: 'respdf',
    component: pdf
  }, {
    path: '/bsgreet',
    name: 'bsgreet',
    component: bsGreetJob
  }, {
    path: '/bslog',
    name: 'bslog',
    component: bslog
  }, {
    path: '/zlgreet',
    name: 'zlgreet',
    component: zlGreetJob
  }, {
    path: '/zllog',
    name: 'zllog',
    component: zllog
  }, {
    path: '/lpgreet',
    name: 'lpgreet',
    component: lpGreetJob
  }, {
    path: '/lplog',
    name: 'lplog',
    component: lplog
  },
  {
    path: '/resume',
    name: 'resume',
    component: resume
  }, {
    path: '/home',
    name: 'home',
    component: () => import('@/views/Home.vue'),
    meta: {
      title: '首页'
    },
    children: [{
      path: '/home/index',
      component: BiBoard,
      meta: {
        title: '首页'
      }
    }, {
      path: '/home/search',
      component: search,
      meta: {
        title: '熵聘人才库'
      }
    }, {
      path: '/home/add',
      component: addRes,
      meta: {
        title: '录入人才'
      }
    }, {
      path: '/home/myinterview',
      component: myinterview,
      meta: {
        title: '我的面试'
      }
    }]
  }, {
    path: '/error',
    name: 'error',
    component: () => import('@/views/404.vue'),
    meta: {
      title: '抱歉，您访问的页面不存在'
    }
  }, {
    path: '/',
    name: 'login',
    component: () => import('@/views/login.vue'),
    meta: {
      title: '熵聘登录页面'
    }
  }, {
    path: '/login',
    name: 'login',
    component: () => import('@/views/login.vue'),
    meta: {
      title: '熵聘登录页面'
    }
  }, {
    path: '/time',
    name: 'time',
    component: () => import('@/views/Time.vue'),
    meta: {
      title: '设置忙碌时间'
    }
  }
]

const router = new VueRouter({
  routes
})
// 设置页面标题
function setPageTitle(to, from, next) {
  if (to.meta && to.meta.title) {
    document.title = to.meta.title;
  } else {
    document.title = 'HPR专注一站式招聘服务'; // 可选的默认标题
  }
  next();
}

// 全局前置守卫
router.beforeEach((to, from, next) => {
  setPageTitle(to, from, next);
});
export default router